import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const PrivateRoute = ({ children, roleRequired }) => {
  const { user, loading } = useAuth();
  const location = useLocation();

  
  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen bg-gray-50">
        <div className="flex flex-col items-center gap-3">
          <div className="animate-spin rounded-full h-10 w-10 border-4 border-blue-600 border-t-transparent"></div>
          <span className="text-gray-500 text-sm">Carregando...</span>
        </div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" state={{ from: location.pathname }} replace />;
  }

 
  // 'staff' = admin_master ou gestor; demais valores exigem papel exato
  const hasRequiredRole =
    !roleRequired ||
    (roleRequired === 'staff'
      ? user.role === 'admin_master' || user.role === 'gestor'
      : user.role === roleRequired);

  if (!hasRequiredRole) {
    return <Navigate to="/dashboard" replace />;
  }

 
  return children;
};

export default PrivateRoute;